import React, { useState, useEffect } from 'react';
import '../styles/Interview.css';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const Interview = () => {
    const [socialIssue, setSocialIssue] = useState('');
    const [geography, setGeography] = useState('');
    const [presentation, setPresentation] = useState('');
    const [purpose, setPurpose] = useState('');
    const [duration, setDuration] = useState('');
    const [toRecord, setToRecord] = useState('');
    const [feedbackInterview, setFeedbackInterview] = useState('');
    const [nextSteps, setNextSteps] = useState('');
    const [contact, setContact] = useState('');

    const [loading, setLoading] = useState(false);
    const [answer, setAnswer] = useState('');
    const [sessionId, setSessionId] = useState(null);
    const [user, setUser] = useState(null);
    const [error, setError] = useState(null);
    const [feedbackGiven, setFeedbackGiven] = useState(false);

    const showdown = require('showdown');
    const converter = new showdown.Converter();

    const handleFeedback = async (feedbackType, interactionId) => {
        try {
            const response = await fetch('https://jnhyo3iqg4.execute-api.eu-north-1.amazonaws.com/feedback', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ 
                "interaction_id": interactionId, 
                "feedback": feedbackType 
            }), // Send interaction ID and feedback text
          });
          console.log('Feedback submitted:', response);
          setFeedbackGiven(true); 
        } catch (error) {
          console.error('Error submitting feedback:', error);
        }
      };
    
    // create a session id for the conversation
    useEffect(() => {
        const sessionId = Math.random().toString(36).substring(7);
        setSessionId(sessionId);
    }, []);
    
    useEffect(() => {
      fetchUser();
    }, []);

    async function fetchUser() {
        try {
          const currentUser = await getCurrentUser();
          const userAttributes = await fetchUserAttributes();
          setUser({ ...currentUser, ...userAttributes });
        } catch (error) {
          console.error('Error fetching user', error);
        }
    }

    const callAPI  = async (e) => {
        e.preventDefault();
        setLoading(true); // Show loader
        setAnswer(null); // Reset answer state
        setError(null);
        setFeedbackGiven(false);
        
        
    try {
        const response = await fetch("https://jnhyo3iqg4.execute-api.eu-north-1.amazonaws.com/interview", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "social_issue": socialIssue,
                "geography": geography,
                "presentation": presentation,
                "purpose": purpose,
                "duration": duration,
                "to_record": toRecord,
                "feedback_interview": feedbackInterview,
                "next_steps": nextSteps,
                "contact": contact,
                "session_id": sessionId,
                "user_id": user.username
            }),
        });


        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
          }
        
        const data = await response.json();
        
        if (data.answer) {
            console.log('Is data.answer an object?', typeof data.answer === 'object');
            setAnswer({
                answer: marked(data.answer),
                interaction_id: data.interactionId
            });
        } else {
            setAnswer('Answer field is missing in the response.');
        }
        } catch (error) {
            setAnswer(error.message);
            console.error('Fetch error:', error);
        } finally {
            setLoading(false);
        }
    };

    function preprocessText(text) {
        // Remove unwanted line breaks and extra spaces
        return text
        .replace(/\n\s*\n/g, '<br><br>') // Maintain double line breaks for paragraphs
        .replace(/\n/g, '<br>');
    }

    function copyToClipboard() {
        const answerDiv = document.getElementById('answerDiv');
        const text = answerDiv.innerText; // Extract only the text content
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        
    }

    const downloadAsPDF = () => {
        const answerDiv = document.getElementById('answerDiv');
        const doc = new jsPDF('p', 'mm', 'a4');
        const pageHeight = doc.internal.pageSize.height;
        const margin = 20;
        const lineHeight = 6; // Adjust line height for smaller font size
        const fontSize = 12; // Set the desired font size
        doc.setFontSize(fontSize);
        let y = margin;
    
        const addTextToPDF = (text) => {
            const lines = doc.splitTextToSize(text, doc.internal.pageSize.width - 2 * margin);
            lines.forEach((line) => {
                if (y + lineHeight > pageHeight - margin) {
                    doc.addPage();
                    y = margin;
                }
                doc.text(line, margin, y, { maxWidth: doc.internal.pageSize.width - 2 * margin });
                y += lineHeight;
            });
        };
    
        const addTextWithColor = (text, color) => {
            const lines = doc.splitTextToSize(text, doc.internal.pageSize.width - 2 * margin);
            doc.setTextColor(color[0], color[1], color[2]); // Set RGB color
            lines.forEach((line) => {
                if (y + lineHeight > pageHeight - margin) {
                    doc.addPage();
                    y = margin;
                }
                doc.text(line, margin, y, { maxWidth: doc.internal.pageSize.width - 2 * margin });
                y += lineHeight;
            });
            doc.setTextColor(0, 0, 0); // Reset to black after adding colored text
        };
    
        if (answer && typeof answer === 'object') {
            const text = answer.answer.replace(/<br\s*\/?>/gi, '\n').replace(/<\/?[^>]+(>|$)/g, "");
    
            // Split the text into phases and add color for titles
            const introductionTitle = "Introduction Phase";
            const substantiveTitle = "Substantive Phase";
            const exitTitle = "Exit Phase";
    
            let remainingText = text;
    
            // Add Introduction Phase
            if (remainingText.includes(introductionTitle)) {
                addTextWithColor(introductionTitle, [255, 20, 147]); // Pink color
                remainingText = remainingText.split(introductionTitle)[1];
            }
    
            // Add Substantive Phase
            if (remainingText.includes(substantiveTitle)) {
                addTextToPDF(remainingText.split(substantiveTitle)[0]); // Add text before Substantive Phase
                addTextWithColor(substantiveTitle, [255, 20, 147]); // Pink color
                remainingText = remainingText.split(substantiveTitle)[1];
            }
    
            // Add Exit Phase
            if (remainingText.includes(exitTitle)) {
                addTextToPDF(remainingText.split(exitTitle)[0]); // Add text before Exit Phase
                addTextWithColor(exitTitle, [255, 20, 147]); // Pink color
                remainingText = remainingText.split(exitTitle)[1];
            }
    
            // Add remaining text
            addTextToPDF(remainingText);
        }
    
        doc.save('answer.pdf');
    };



    return (
        <div>
            <div className="title-section">
                <h2 className="title-text">Interview Scripter</h2>
                <img src="https://rfc-info.s3.eu-north-1.amazonaws.com/Interview_Scripter.png" alt="RFC Problem Analysis" className="title-icon2" />
            </div>
                <h4>Receive help on how to collect your own data!</h4>
                <form onSubmit={callAPI}>
                <div className="input-grid">
                    <div className="input-container">
                        <label>Enter the social issue:</label>
                        <input
                            type="text"
                            id="socialIssue"
                            placeholder="Enter social issue..."
                            required
                            value={socialIssue}
                            onChange={(e) => setSocialIssue(e.target.value)}
                            />
                    </div>
                    <div className="input-container">
                        <label htmlFor="geography">Enter the geography:</label>
                        <input
                            type="text"
                            id="geography"
                            placeholder="Enter geography..."
                            required
                            value={geography}
                            onChange={(e) => setGeography(e.target.value)}
                        />
                    </div>
                    <div className="input-container">
                        <label htmlFor="presentation">Enter the presentation:</label>
                        <textarea
                            id="presentation"
                            placeholder="Enter presentation..."
                            required
                            value={presentation}
                            onChange={(e) => setPresentation(e.target.value)}
                        />
                        <p className="placeholder-text-interview">Please present yourself. E.g. Hello, my name is __, and I am the Program Coordinator at __. Our organization is dedicated to __ by __. With __ years of experience in this field, I am passionate about helping __. </p>
                    </div>
                    <div className="input-container">
                        <label htmlFor="purpose">Enter the purpose:</label>
                        <textarea
                            id="purpose"
                            placeholder="Enter purpose..."
                            required
                            value={purpose}
                            onChange={(e) => setPurpose(e.target.value)}
                        />
                        <p className="placeholder-text-interview">Please state the purpose of the interview. E.g. The purpose of this interview is to gather information on __ to help us understand __. I am interested in learning about __ to help me improve __. </p>
                    </div>
                    <div className="input-container">
                        <label htmlFor="duration">Enter the duration:</label>
                        <input
                            type="text"
                            id="duration"
                            placeholder="Enter duration..."
                            required
                            value={duration}
                            onChange={(e) => setDuration(e.target.value)}
                        />
                        <p className="placeholder-text-interview">Please state the duration of the interview. E.g. The interview will take approximately __ minutes.</p>
                    </div>
                    <div className="input-container">
                        <label htmlFor="toRecord">Would the interview be recorded:</label>
                        <select
                            id="toRecord"
                            required
                            value={toRecord}
                            onChange={(e) => setToRecord(e.target.value)}
                        >
                            <option value="">Select Yes or No</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    <div className="input-container">
                        <label htmlFor="feedbackInterview">Enter your feedback:</label>
                        <textarea
                            id="feedbackInterview"
                            placeholder="Enter your feedback..."
                            required
                            value={feedbackInterview}
                            onChange={(e) => setFeedbackInterview(e.target.value)}
                        />
                        <p className="placeholder-text-interview">Please state if you want any feedback for the interview. E.g. I would like to receive feedback on __.</p>
                    </div>
                    <div className="input-container">
                        <label htmlFor="nextSteps">Are there any next steps planned after the interview:</label>
                        <select
                            id="nextSteps"
                            required
                            value={nextSteps}
                            onChange={(e) => setNextSteps(e.target.value)}
                        >
                            <option value="">Select Yes or No</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                        {/* <p className="placeholder-text-interview">Please state if there are any next steps planned after the interview. E.g. Our next steps are: 1- Analyzing the feedback received to improve our programs 2- Scheduling follow-up sessions to address any concerns or suggestions 3- Offering additional resources or support based on the feedback</p> */}
                    </div>  
                    <div className="input-container">
                        <label htmlFor="contact">Enter contact:</label>
                        <input
                            type="text"
                            id="contact"
                            placeholder="Enter contact..."
                            required
                            value={contact}
                            onChange={(e) => setContact(e.target.value)}
                        />
                    </div>
                    </div>
                    <br/>
                        <p className="placeholder-text-ai">Note: AI-generated content may contain errors. Please verify the information.</p>
                    <div className="input-container">
                        <button type="submit">Generate Interview Scripter</button>
                    </div>
                </form>
                {loading && (
                    <div className="loader">
                        <span className="loader-text">Loading...</span>
                        <span className="load"></span>
                    </div>
                )}
                <div id="answerDiv" aria-live="polite">
                {answer && typeof answer === 'object' ? (
                    <div>
                        <p><strong>Answer:</strong></p>
                        <div 
                        className="inline-text no-cursive"
                        dangerouslySetInnerHTML={{ __html: marked(preprocessText(answer.answer))}}  
                        />
                        <br/>
                        <p className="placeholder-text-ai">Note: AI-generated content may contain errors. Please verify the information.</p>
                        <div class="button-row-container">
                        <div onClick={copyToClipboard} class="Btn" role="button" tabindex="0">
                            <span class="text">Copy</span>
                            <span class="svgIcon">
                                <svg fill="white" viewBox="0 0 384 512" height="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M280 64h40c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h40 9.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H280zM64 112c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H304v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112H64zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"></path>
                                </svg>
                            </span>
                        </div>
                        <button onClick={downloadAsPDF} className="pdf-button">Download as PDF</button>
                    </div>
                    {!feedbackGiven ? (
                        <div className="input-row">
                            <div className="checkboxButton" onClick={() => handleFeedback('Like', answer.interaction_id)}>
                                <label className="feedback">
                                    <input type="checkbox" />
                                    <svg
                                        id="Glyph"
                                        version="1.1"
                                        viewBox="0 0 32 32"
                                        xmlSpace="preserve"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                    >
                                        <path
                                            d="M29.845,17.099l-2.489,8.725C26.989,27.105,25.804,28,24.473,28H11c-0.553,0-1-0.448-1-1V13  c0-0.215,0.069-0.425,0.198-0.597l5.392-7.24C16.188,4.414,17.05,4,17.974,4C19.643,4,21,5.357,21,7.026V12h5.002  c1.265,0,2.427,0.579,3.188,1.589C29.954,14.601,30.192,15.88,29.845,17.099z"
                                            id="XMLID_254_"
                                        ></path>
                                        <path
                                            d="M7,12H3c-0.553,0-1,0.448-1,1v14c0,0.552,0.447,1,1,1h4c0.553,0,1-0.448,1-1V13C8,12.448,7.553,12,7,12z   M5,25.5c-0.828,0-1.5-0.672-1.5-1.5c0-0.828,0.672-1.5,1.5-1.5c0.828,0,1.5,0.672,1.5,1.5C6.5,24.828,5.828,25.5,5,25.5z"
                                            id="XMLID_256_"
                                        ></path>
                                    </svg>
                                </label>
                            </div>
                            <div className="checkboxButton" onClick={() => handleFeedback('Dislike', answer.interaction_id)}>
                                <label className="feedback">
                                    <input type="checkbox" />
                                    <svg
                                        id="Glyph"
                                        version="1.1"
                                        viewBox="0 0 32 32"
                                        xmlSpace="preserve"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                    >
                                        <path d="M2.156,14.901l2.489-8.725C5.012,4.895,6.197,4,7.528,4h13.473C21.554,4,22,4.448,22,5v14  c0,0.215-0.068,0.425-0.197,0.597l-5.392,7.24C15.813,27.586,14.951,28,14.027,28c-1.669,0-3.026-1.357-3.026-3.026V20H5.999  c-1.265,0-2.427-0.579-3.188-1.589C2.047,17.399,1.809,16.12,2.156,14.901z"
                                            id="XMLID_259_"></path>
                                        <path d="M25.001,20h4C29.554,20,30,19.552,30,19V5c0-0.552-0.446-1-0.999-1h-4c-0.553,0-1,0.448-1,1v14  C24.001,19.552,24.448,20,25.001,20z M27.001,6.5c0.828,0,1.5,0.672,1.5,1.5c0,0.828-0.672,1.5-1.5,1.5c-0.828,0-1.5-0.672-1.5  C25.501,7.172,26.173,6.5,27.001,6.5z"
                                            id="XMLID_260_"></path>
                                    </svg>
                                </label>
                            </div>
                        </div>
                    ) : (
                        <p className="feedback-thanks">Thank you for your feedback! 😄</p>
                    )}
                </div>
            ) : (
        <p className="error">{answer}</p>
            )}
        </div>
            </div>
        );
    };

export default Interview;